<form
  *ngIf="groupForm"
  class="field-dialog__content__scroll p-24"
  fxLayout="column"
  autocomplete="off"
  name="form"
  [formGroup]="groupForm"
  autocomplete="off"
  fusePerfectScrollbar
>
  <h3 class="field-dialog__content__scroll__title" *ngIf="!disabledOrViewMode">
    {{ 'GROUPS.DIALOG.SUBTITLE' | translate }}
  </h3>

  <div class="field-outline-form" fxLayout="column" fxLayoutAlign="start center">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'GROUPS.HEADER.GROUP_NAME' | translate }}</mat-label>

      <input type="text" matInput formControlName="name" required />

      <mat-error *ngIf="groupForm.get('name').hasError('required')">
        {{ 'GROUPS.DIALOG.ERROR.NAME_REQUIRED' | translate }}
      </mat-error>
      <mat-error *ngIf="groupForm.get('name').hasError('group_name_duplicated')">
        {{ 'GROUPS.DIALOG.ERROR.NAME_DUPLICATED' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'GROUPS.HEADER.DESCRIPTION' | translate }}</mat-label>
      <textarea
        matInput
        matTextareaAutosize
        matAutosizeMinRows="2"
        matAutosizeMaxRows="10"
        formControlName="description"
      >
      </textarea>

      <span class="hint-inside-input"> ({{ groupForm.get('description').value?.length || 0 }}/200) </span>

      <mat-error *ngIf="groupForm.get('description').hasError('maxlength')">
        {{ 'GROUPS.DIALOG.ERROR.DESCRIPTION_MAX_LENGTH' | translate }}
      </mat-error>
    </mat-form-field>
  </div>
</form>
